import { useBulkSignalsInput } from "./utils";
import { ArchivedFilter, AssigneeValue } from "@avenueops/shared-types";
import { DropdownSelect } from "@avenueops/web-components";
import { OvalLoader } from "@avenueops/web-components";
import { ExclamationTriangleIcon, UserCircleIcon } from "@heroicons/react/24/outline";
import { WorkflowProcessPriority } from "@prisma/client";
import SetDynamicAssigneeDropdown from "components/SetDynamicAssigneeDropdown";
import Tooltip from "components/generic-building-blocks/Tooltip";
import PriorityButton, { getWorkflowProcessPriorityIcon } from "components/signals/processPage/PriorityButton";
import { iconClassName, iconParentClassName } from "components/workflows/BulkActionButtons";
import { useDeselectAll } from "context/BulkActionsContext";
import _ from "lodash";
import React from "react";
import { useBulkAssignProcessMutation, useBulkSetPriorityMutation } from "utils/state/processes";
import { noOp } from "utils/state/utils";

interface Props {
  archived: ArchivedFilter;
  isDashboard: boolean;
}

export default function ProcessTablePriorityDropdown({ archived, isDashboard }: Props) {
  const bulkSignalsInput = useBulkSignalsInput({ archived, isDashboard });
  const deselectAll = useDeselectAll();

  const { mutateAsync: bulkPriorityMutation, isLoading } = useBulkSetPriorityMutation({
    onSuccess: async () => {
      deselectAll();
    },
  });
  return isLoading ? (
    <div className="ml-2">
      <OvalLoader type="DEFAULT" size={20} />
    </div>
  ) : (
    <>
      <Tooltip text="Priority" justify={"CENTER"} width="FIT" duration="duration-[5ms]">
        <DropdownSelect
          name="bulkPriority"
          options={[
            { value: "", label: "No priority", icon: getWorkflowProcessPriorityIcon(null) },
            ...Object.values(WorkflowProcessPriority).map((value) => {
              return {
                value: value,
                label: _.capitalize(value),
                icon: getWorkflowProcessPriorityIcon(value),
              };
            }),
          ]}
          type="ICON"
          IndicatorIcon={ExclamationTriangleIcon}
          onChange={(value: string | undefined) => {
            bulkPriorityMutation({
              bulkSignalsInput,
              priority: value ? (value as WorkflowProcessPriority) : null,
            }).catch(noOp);
          }}
        />
      </Tooltip>
    </>
  );
}
